<div class="row-details search-item clickable"
     (click)="rowClicked($event, searchResult)">
    <div class="item-status"
         *ngIf="searchResult.statusText">
        <div class="highlighting"
             [ngClass]="searchResult.statusClass">{{searchResult.statusText}}</div>
    </div>
    <div class="item-status"
         *ngIf="searchResult.statusKey">
        <div class="highlighting"
             [ngClass]="searchResult.statusClass">{{searchResult.statusKey | translate}}</div>
    </div>
    <div class="item-description"
         [ngSwitch]="searchResult.category">
        <aa-search-result-back-auth-user *ngSwitchCase="'back-user'"
                                         [item]="searchResult">
        </aa-search-result-back-auth-user>
        <aa-search-result-back-auth-entity *ngSwitchCase="'back-entity'"
                                           [item]="searchResult">
        </aa-search-result-back-auth-entity>
        <aa-search-result-bckp-job *ngSwitchCase="'bckp-job'"
                                   [item]="searchResult"></aa-search-result-bckp-job>
        <aa-search-result-bckp-server *ngSwitchCase="'bckp-server'"
                                      [item]="searchResult">
        </aa-search-result-bckp-server>
        <aa-search-result-bckp-policy *ngSwitchCase="'bckp-policy'"
                                      [item]="searchResult">
        </aa-search-result-bckp-policy>
        <aa-search-result-comp-instance *ngSwitchCase="'comp-instance'"
                                        [item]="searchResult">
        </aa-search-result-comp-instance>
        <aa-search-result-its2-request *ngSwitchCase="'its2-request'"
                                       [item]="searchResult">
        </aa-search-result-its2-request>
    </div>
</div>
